import {Button} from "antd";

export interface RegStepMicrosoftWelcomeProps {
  orgName?: string;
  toDashboard: () => void;
}

export default function RegStepMicrosoftWelcome({orgName, toDashboard}: RegStepMicrosoftWelcomeProps) {
  return (
    <div className={"success-next step full"}>
      <div className="emoji">&#128075;</div>
      <h2>Welcome!</h2>
      <p>You've been added to {orgName ? `the ${orgName} workspace` : "your workspace"}.</p>

      <footer>
        <Button size={"large"} className={"primary"} onClick={toDashboard}>Continue</Button>
      </footer>
    </div>
  );
}
